export default __webpack_public_path__ + "static/media/mdb.1c712df3.png";